<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">会员排名</div>
    </div>
    <van-tabs v-model="tabActive">
      <van-tab title="订单排名">
        <div class="padding-0-15 padding-b-8">
          <div class="search-wrap">
          <div class="search-form">
            <div class="search-item search-input-item">
              <input type="text" class="search-input"  v-model="searchOrderForm.id" placeholder="会员ID"/>
            </div>
          </div>
          <div class="btn-wrap">
            <div class="search-btn" @click="getOrderList">查询</div>
          </div>
        </div>
        </div>
        <div class="gray"></div>
        <div class="padding-0-15">
          <div class="title-text-official padding-11-0 padding-b-19">列表</div>
          <div class="table-wrapper">
            <el-table :data="orderList" border style="width: 100%">
              <el-table-column prop="date" label="排名" width="52" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.sequence }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="会员ID" width="85" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.id }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="订单数量" width="85" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.orderNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="注册时间" width="120" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.createTimeStr }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="totalOrder>0" :total="totalOrder" :page.sync="searchOrderForm.pageNo" :limit.sync="searchOrderForm.pageSize" @pagination="getOrderList" />
          </div>
        </div>
      </van-tab>
      <van-tab title="佣金排名">
        <div class="padding-0-15">
          <div class="search-wrap">
          <div class="search-form">
            <div class="search-item search-box">
              <span>排名方式：</span>
              <RadioGroup v-model="searchProfitForm.rankType">
                <Radio label="1">
                  <span>累计佣金</span>
                </Radio>
                <Radio label="2">
                  <span>已提现佣金</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="search-item search-input-item">
              <input type="text" class="search-input"  v-model="searchProfitForm.id" placeholder="会员ID"/>
            </div>
          </div>
          <div class="btn-wrap">
            <div class="search-btn" @click="getProfitList">查询</div>
          </div>
        </div>
        </div>
        <div class="gray"></div>
        <div class="padding-0-15 padding-b-8">
          <div class="title-text-official padding-11-0 padding-b-19">列表</div>
          <div class="table-wrapper">
            <el-table :data="profitList" border style="width: 100%">
              <el-table-column prop="date" label="排名" width="50" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.sequence }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="会员ID" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.id }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="累计佣金" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.commission }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="已提现佣金" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.withdraw }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="剩余佣金" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.balance }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="注册时间" width="90" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.createTimeStr }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="totalProfit>0" :total="totalProfit" :page.sync="searchProfitForm.pageNo" :limit.sync="searchProfitForm.pageSize" @pagination="getProfitList" />
          </div>
        </div>
      </van-tab>
      <van-tab title="团队排名">
        <div class="padding-0-15">
          <div class="search-wrap">
          <div class="search-form">
            <div class="search-item search-box">
              <span>排名方式：</span>
              <RadioGroup v-model="searchTeamForm.rankType">
                <Radio label="4">
                  <span>直推团队</span>
                </Radio>
                <Radio label="5">
                  <span>二级团队</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="search-item search-input-item">
              <input type="text" class="search-input"  v-model="searchTeamForm.id" placeholder="会员ID"/>
            </div>
          </div>
          <div class="btn-wrap">
            <div class="search-btn" @click="getTeamList">查询</div>
          </div>
        </div>
        </div>
        <div class="gray"></div>
        <div class="padding-0-15 padding-b-8">
          <div class="title-text-official padding-11-0 padding-b-19">列表</div>
          <div class="table-wrapper">
            <el-table :data="teamList" border style="width: 100%">
              <el-table-column prop="date" label="排名" width="50" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.sequence }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="会员ID" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.id }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="团队人数" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.teamNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="直推数量" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.directNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="二级数量" width="80" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.secondNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="注册时间" width="90" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.createTimeStr }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="totalTeam>0" :total="totalTeam" :page.sync="searchTeamForm.pageNo" :limit.sync="searchTeamForm.pageSize" @pagination="getTeamList" />
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import { RadioGroup, Radio } from 'view-design'
import { numFormatter } from '@/utils/date'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import sort from '@/javaApi/sort'
const sortModel = new sort()
export default {
  name: "Sort",
  components: {
    Pagination,
    RadioGroup,
    Radio
  },
  data: function() {
    return {
      tabActive: 0,
      listLoading: false,
      totalOrder: 0,
      orderList:[],
      searchOrderForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '0', //排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      totalProfit: 0,
      profitList:[],
      searchProfitForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '1',//排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      totalTeam: 0,
      teamList:[],
      searchTeamForm: {
        pageNo: 1,
        pageSize: 10,
        rankType: '4',//排名方式 0:订单数量 1:累计佣金 2:已提现佣金 3:团队人数 4:直推团队 5:二级团队
        id: undefined,
      },
      platformUuid: getPlatformUuid(),
    }
  },
  computed:{
    profitRankType() {
      return this.searchProfitForm.rankType;
    },
    teamRankType() {
      return this.searchTeamForm.rankType;
    }
  },
  watch: {
    profitRankType() {
      this.searchProfitForm.pageNo = 1;
    },
    teamRankType() {
      this.searchTeamForm.pageNo = 1;
    }
  },
  created() {
    //订单排名
    this.getOrderList();
    //佣金排名
    this.getProfitList();
    //团队排名
    this.getTeamList();
  },
  methods: {
    changeTab: function(index) {
      this.tabActive = index;
    },
    getOrderList(){
      let userParam = this.searchOrderForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        userParam.platformUuid =  this.platformUuid
      }
      userParam = this.formateInit(userParam)
      that.listLoading = false
      if(userParam.id){
        userParam.id = numFormatter(userParam.id)
      }
      sortModel.getOrderList(userParam).then(response=>{
        console.log(response)
        let res = response.data
        if(res.code === 200){
          that.listLoading = false
          that.orderList = res.data?res.data.list:[]
          that.orderList = that.formateData(that.orderList, userParam.pageNo, userParam.pageSize)
          that.totalOrder = res.data.total;
        }else{
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }

      })

    },
    getProfitList(){
      let userParam = this.searchProfitForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        userParam.platformUuid =  this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if(userParam.id){
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getCommissionList(userParam).then(response=>{
        console.log(response)
        let res = response.data
        if(res.code === 200){
          that.listLoading = false
          that.profitList = res.data?res.data.list:[]
          that.profitList = that.formateData(that.profitList, userParam.pageNo, userParam.pageSize)
          that.totalProfit = res.data.total;
        }else{
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }

      })

    },
    getTeamList(){
      let userParam = this.searchTeamForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        userParam.platformUuid =  this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if(userParam.id){
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getTeamList(userParam).then(response=>{
        console.log(response)
        let res = response.data
        if(res.code === 200){
          that.listLoading = false
          that.teamList = res.data?res.data.list:[]
          that.teamList = that.formateData(that.teamList, userParam.pageNo, userParam.pageSize)
          that.totalTeam = res.data.total;
        }else{
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }

      })
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    formateData(data, pageNo, pageSize){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    changePageOrder(value){
      this.searchOrderForm.pageNo = value
      this.getOrderList()
    },
    changePagesizeOrder(value){
      this.searchOrderForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchOrderForm.pageNo == 1){
        this.getOrderList()
      }
    },
    changePageProfit(value){
      this.searchProfitForm.pageNo = value
      this.getProfitList()
    },
    changePagesizeProfit(value){
      this.searchProfitForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchProfitForm.pageNo == 1){
        this.getProfitList()
      }
    },
    changePageTeam(value){
      this.searchTeamForm.pageNo = value
      this.getTeamList()
    },
    changePagesizeTeam(value){
      this.searchTeamForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchTeamForm.pageNo == 1){
        this.getTeamList()
      }
    },
  }
}
</script>

<style lang="less" scoped>
.van-cell{
  font-family: Alibaba-PuHuiTi-R;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  align-items: center;
  img{
    width: 30px;
    margin-right: 10px;
  }
}

/deep/.van-cell__title{
  font-size: 14px;
  color: #666666;
}
/deep/.van-checkbox__icon{
  width: 22px;
  height: 22px;
}
/deep/.van-tabs__wrap{
  height: 32px;
  padding: 0 15px;
  .van-tabs__nav{
    background: #EDEDED;
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 12px;
    color: #666666;
  }
  .van-tabs__nav--line{
    padding: 0;
    .van-tab--active{
      height: 28px;
      background: #FFFFFF;
      border-radius: 14px;
      margin: 2px;
      color: #222222;
    }
  }
  .van-tabs__line{
    width: 0;
    height: 0;
  }
}
.search-wrap{
  margin-top: 19px;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/sort/Index.vue